module.exports = __webpack_public_path__ + "img/big4-16.f6c91992.jpg";